const searchModel = {
    
    currentSearchResult: [],
    downloadedHandbooks: []
  };
  
  export default searchModel;
  